import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { publishReplay, refCount } from 'rxjs/operators';
import 'rxjs/Rx';
import { Province } from '../../models/province.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Rx';
import { DeployType } from 'app/models/kloy.model';

@Injectable()
export class KPromoService {

  public deployTypeCodes = {
    KPROMO: "KPROMO",
    IBC: "IBC"
  }
  private baseUrl = "/koncentro-promo";

  constructor (
    private h: HttpClientService,
    private srvNotify: MessageService
  ) { }

  getDeployType(messageInstanceId: number): Observable<Array<DeployType>> {

    return this.h.get(`${this.baseUrl}/campaign/message-instance/deployType?message_instance_id=${messageInstanceId}`)
      .map(res => {
        return res;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/kloy/kpromo.service.ts